import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Create } from "../../../actorTyes";
import { Adapter } from "../../../../shared/adapter";
import { ActorTypeRaw, Result } from "../../../../interfaces";
import { ActorTypesAdapter } from "../../../../adapter/actorTypes-adapter";

export const FETCH_CREATE_ACTOR_TYPES_REQUEST = 'FETCH_CREATE_ACTOR_TYPES_REQUEST';
export const FETCH_CREATE_ACTOR_TYPES_SUCCESS = 'FETCH_CREATE_ACTOR_TYPES_SUCCESS';
export const FETCH_CREATE_ACTOR_TYPES_FAILURE = 'FETCH_CREATE_ACTOR_TYPES_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchCreateActorTypesRequest = () => {
    return {
        type: FETCH_CREATE_ACTOR_TYPES_REQUEST,
    };
};

const fetchCreateActorTypesSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_CREATE_ACTOR_TYPES_SUCCESS,
        payload: data
    };
};

const fetchCreateActorTypesFailure = (error: any) => {
    return {
        type: FETCH_CREATE_ACTOR_TYPES_FAILURE,
        payload: error,
    };
};

export const clear = ()=>{
    return {
        type: "CLEAR_DATA",
    };  
}

export const create = (actorType:ActorTypeRaw) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchCreateActorTypesRequest());
        try {
            const response = await Create(actorType);
            dispatch(fetchCreateActorTypesSuccess(
                Adapter.from(response.data).to((value) => new ActorTypesAdapter(value).adapt())
            ));
        } catch (error: any) {
            dispatch(fetchCreateActorTypesFailure(error.message));
        }
    };
};
